import { render, staticRenderFns } from "./KakaoLogin.vue?vue&type=template&id=b2a70a36&scoped=true&"
import script from "./KakaoLogin.vue?vue&type=script&lang=js&"
export * from "./KakaoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a70a36",
  null
  
)

export default component.exports